// Default lookback window (in days) used only for the previous-period
// comparison calls when the user hasn't picked an explicit date range.
// This never changes what the rest of a board fetches/displays — it just
// gives the "vs previous period" delta a concrete, explainable window.
const DEFAULT_LOOKBACK_DAYS = { daily: 30, weekly: 84, monthly: 365 };

export function resolveCurrentRange(period, dateRange) {
  if (dateRange?.[0] && dateRange?.[1]) {
    return { from: new Date(dateRange[0]), to: new Date(dateRange[1]) };
  }
  const days = DEFAULT_LOOKBACK_DAYS[period] || 30;
  const to = new Date();
  const from = new Date(to);
  from.setDate(from.getDate() - days);
  return { from, to };
}

export function previousRange({ from, to }) {
  const spanMs = to.getTime() - from.getTime();
  const prevTo = new Date(from.getTime() - 1);
  const prevFrom = new Date(prevTo.getTime() - spanMs);
  return { from: prevFrom, to: prevTo };
}

export function rangeToParams({ from, to }) {
  return { from_date: from.toISOString(), until_date: to.toISOString() };
}

export function computeDelta(current, previous) {
  const cur = Number(current) || 0;
  const prev = Number(previous) || 0;
  if (prev === 0) {
    if (cur === 0) return { text: "", dir: "up" };
    return { text: "+100%", dir: "up" };
  }
  const pct = ((cur - prev) / prev) * 100;
  const dir = pct >= 0 ? "up" : "down";
  const text = `${pct >= 0 ? "+" : ""}${pct.toFixed(1)}%`;
  return { text, dir };
}
